import React, { useContext } from 'react';
import { Link, withRouter, RouteComponentProps } from 'react-router-dom';
import UserContext from 'components/Provider/UserProvider';
import { Menu } from 'antd';
import styles from './Navigation.module.css';

const Navigation = ({ location: { pathname } }: RouteComponentProps) => {
  const { user, loading } = useContext(UserContext);

  const selectedKeys = [];

  const menuItems = [
    {
      label: 'Decks',
      key: 'decks',
      href: '/my-decks',
      additionalPaths: ['/decks'],
      hidden: !user && !loading,
      children: [
        {
          label: 'Token finder',
          key: 'token-finder',
          href: '/proxy?type=tokens',
        },
      ],
    },
    {
      label: 'Wants',
      key: 'wants',
      href: '/my-wants',
      additionalPaths: ['/wants'],
      hidden: !user && !loading,
    },
    {
      label: 'Collection',
      key: 'collection',
      href: '/collection',
      hidden: !user && !loading,
      children: [
        {
          label: 'Set Completion',
          key: 'by-set',
          href: '/collection/by-set',
        },
      ],
    },
    {
      label: 'Advanced Search',
      key: 'search',
      href: '/search',
    },
  ]
    .filter(({ hidden }) => !hidden)
    .map(({ label, href, additionalPaths, ...item }) => {
      const active = [href, ...(additionalPaths ?? [])].some((path) =>
        pathname.includes(path)
      );

      if (active) {
        selectedKeys.push(item.key);
      }

      return {
        ...item,
        label: (
          <Link className={styles.link} to={href}>
            {label}
          </Link>
        ),
        children: item.children?.map((child) => ({
          ...child,
          label: (
            <Link className={styles.link} to={child.href}>
              {child.label}
            </Link>
          ),
        })),
      };
    });

  return (
    <Menu
      className={styles.menu}
      mode="horizontal"
      items={menuItems}
      selectedKeys={selectedKeys}
    />
  );
};

export default withRouter(Navigation);
